/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React from 'react';
import jsonp from 'jsonp';
import { connect } from 'react-redux';
import {
  getUserPrcData,
  userData,
  toggleLoginBox,
} from 'components/Login/redux';
import _get from 'lodash.get';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import {
  setSessionStorage,
  getSessionStorage,
  deleteSessionStorage,
} from 'utils/storageUtils';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  isPrimeUser,
  getMsidFromPath,
  reloadWrtPrimeUnlock,
  loadFacebookJs,
  getQueryParams,
  areDatesEqual,
} from 'utils/common';
import AboundSignUpPopup from 'components_v2/common/AboundSignUpPopup/AboundSignUpPopup';
import AboundSignUpPopupLoggedIn from 'components_v2/common/AboundSignUpPopupLoggedIn/AboundSignUpPopupLoggedIn';
import AboundSDK from 'components_v2/common/Abound/AboundSDK';
import { loadLoginAboundPoints } from 'components_v2/common/Abound/redux';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import alertLogger from 'helpers/logAlert/AlertLogger';
import s from './Login.scss';
import SignInLoader from './SignInLoader';
import Cookie from '../../utils/cookies';
import {
  getGeoCountry,
  getPrcCookieValue,
  getUserTimesPointByPRC,
  getUserTimesPaidPoints,
  isPrimeNotActive,
  savingCallIfTimesPrime,
  checkGracePeriod,
  checkPreExpireDate,
} from '../../utils/primeUtil';

import { isUser, getNewUser } from './User';
import { fireGAEvent } from './Track';
import OnetapsigninV2 from './OnetapsigninV2';
import TrueCallerLogin from './TrueCallerLogin';
import LoggedInUser from './LoggedInUser';
import MobileOnlySignInLoader from './MobileOnlyLogin/MobileOnlySignInLoader';
import { loadJssoCrossWalk } from './LoadJssoCrossWalk';
import {
  ACTIVE_PRIME_USER_PRC_ARR,
  LOGIN_MAPPED_ON_LIVE,
  ALREADY_PRIME_USER_STORAGE_NAME,
  PRC_FOR_NEVER_REGISTER,
  PRC_PRIME_API_DESKTOP,
  PRC_PRIME_API_MOB,
  NEWSLETTER_SUBSCRIPTION_API,
  NEWSLETTER_DEFAULT_VAL,
} from '../../constants';

function addScroll() {
  const $body = document.getElementsByTagName('body')[0];
  let classList = $body.className;
  const classListArr = classList ? classList.split(' ') : [];
  if (classListArr.indexOf('disable-scroll') !== -1) {
    return;
  }
  classListArr.push('disable-scroll');
  classList = classListArr.join(' ');
  $body.className = classList;
}

function removeScroll() {
  const $body = document.getElementsByTagName('body')[0];
  let classList = $body.className;
  const classListArr = classList ? classList.split(' ') : [];
  const disableArrayIndex = classListArr.indexOf('disable-scroll');
  if (disableArrayIndex === -1) {
    return;
  }
  classListArr.splice(disableArrayIndex, 1);
  classList = classListArr.join(' ');
  $body.className = classList;
}

function gaCall(label, screenName) {
  fireGAEvent(label, screenName || 'Login_Screen');
}
const LOGIN_EVENT_NAME = 'login_TOI_user';
const LOGOUT_EVENT_NAME = 'logout_TOI_user';
const FBLOGIN_EVENT_NAME = 'login_with_fb';
const GPLUSLOGIN_EVENT_NAME = 'login_with_google';
const GPLUSLOGIN_EVENT_NAME_FEDCM = 'login_with_google_fedcm';
const LOGIN_WITH_CRED_EVENT_NAME = 'login_with_cred';
const GPLUSLOGIN_CREDENTIAL_EVENT_NAME = 'login_with_credential_google';
const CONSENT_GIVEN_EVENT_NAME = 'consent_given';
const LOGIN_PAGE_REFRESH = 'login_page_refresh';
const LOGIN_POPUP_CLOSE = 'login_popup_close';

export function loginEventEmitter(
  callback,
  dataObj,
  numberToPrefill,
  ga4EventTypeValue,
) {
  const loginEvent = new Event(LOGIN_EVENT_NAME);
  if (typeof callback === 'function') {
    loginEvent.customCallBack = callback;
  }
  if (
    typeof dataObj !== 'undefined' &&
    dataObj.constructor === Object &&
    Object.keys(dataObj).length > 0
  ) {
    loginEvent.customDataObj = dataObj;
  }
  if (numberToPrefill !== undefined) {
    loginEvent.numberToPrefill = numberToPrefill;
  }
  if (ga4EventTypeValue) {
    setSessionStorage('ga4EventTypeValue', ga4EventTypeValue);
  }

  window.dispatchEvent(loginEvent);
}
export function loginCredEmitter(callback) {
  const credLoginEvent = new Event(LOGIN_WITH_CRED_EVENT_NAME);
  if (typeof callback === 'function') {
    credLoginEvent.customCallBack = callback;
  }
  if (
    typeof dataObj !== 'undefined' &&
    dataObj.constructor === Object &&
    Object.keys(dataObj).length > 0
  ) {
    credLoginEvent.customDataObj = dataObj;
  }

  window.dispatchEvent(credLoginEvent);
}
export function logOutEventEmitter(callback) {
  const logoutEvent = new Event(LOGOUT_EVENT_NAME);
  if (typeof callback === 'function') {
    logoutEvent.customCallBack = callback;
  }
  window.dispatchEvent(logoutEvent);
}

export function consentGivenEventEmitter() {
  const consentGivenEvent = new Event(CONSENT_GIVEN_EVENT_NAME);
  window.dispatchEvent(consentGivenEvent);
}

export function loginWithFBEventEmitter() {
  const fbLoginEvent = new Event(FBLOGIN_EVENT_NAME);
  window.dispatchEvent(fbLoginEvent);
}

export function loginWithGoogleEventEmitter() {
  const gplusLoginEvent = new Event(GPLUSLOGIN_EVENT_NAME);
  window.dispatchEvent(gplusLoginEvent);
}
export function loginWithGoogleCredentialsEventEmitter() {
  const gplusCredentialLoginEvent = new Event(GPLUSLOGIN_CREDENTIAL_EVENT_NAME);
  window.dispatchEvent(gplusCredentialLoginEvent);
}
class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      showSignIn: false,
      loggedIn: false,
      // user: {},
      firstName: '',
      thumbImg: '',
      doNotClose: false,
      jssoCrosswalkObj: '',
      isPrimeUser: false,
      inGracePeriod: false,
      isPreExpired: false,
      newsLetterSubscription: false,
    };
    this.registeredOrLogdInUserType = '';
    this.fbOrGoogleSignSuccessful = false;
    this.config = {
      single_user_id: 'SINGLE_USER',
    };

    // always ingore settings for live.
    this.api_urls = {};
    this.api_urls.jsso =
      __PROD__ || LOGIN_MAPPED_ON_LIVE
        ? '//jsso.indiatimes.com'
        : '//jssostg.indiatimes.com';
    this.api_urls.socialappsintegrator =
      __PROD__ || LOGIN_MAPPED_ON_LIVE
        ? '//socialappsintegrator.indiatimes.com/'
        : '//testsocialappsintegrator.indiatimes.com/';

    this.userList = [];
    this.screenName = '';
    this.showToiSubscriptionText = false; //to show toi subscription text on top of initial login screen
  }

  componentDidMount() {
    this.channel = 'toi';
    this.checkIfPrimeUser();
    if (getGeoCountry() !== 'US') {
      this.setState({
        newsLetterSubscription: true,
      });
    }
    loadJssoCrossWalk(() => {
      if (document.domain.indexOf('timesofindia.com') >= 0) {
        document.domain = 'timesofindia.com';
        this.channel = 'toi-wap';
      }
      //this.isPrimeUserBeforeLogin = isPrimeUser();
      this.checkUserStatus(false, this.loginInitCallback);
      this.setSSOInWindow();
      document.body.addEventListener('keyup', this.closeModalOnEscapeKeyPress);
      setTimeout(() => {
        if (document.getElementById('login-popup')) {
          document
            .getElementById('login-popup')
            .addEventListener('click', this.closeSignInModalOnOutsideClick);
        }
      }, 0);
      this.state.isMobile = this.props.isMobileState;
      window.addEventListener(
        LOGIN_EVENT_NAME,
        this.loginEventFn.bind(this, this.props.onChangeTransform),
      );
      window.addEventListener(LOGOUT_EVENT_NAME, this.logout.bind(this));
      window.addEventListener(FBLOGIN_EVENT_NAME, this.loginWithFacebook);
      window.addEventListener(GPLUSLOGIN_EVENT_NAME, this.loginWithGoogleOld);
      window.addEventListener(
        GPLUSLOGIN_EVENT_NAME_FEDCM,
        this.loginWithGoogleFedcm,
      );
      window.addEventListener(LOGIN_WITH_CRED_EVENT_NAME, this.loginWithCred);
      window.addEventListener(
        GPLUSLOGIN_CREDENTIAL_EVENT_NAME,
        this.checkUserStatus,
      );
      window.addEventListener(
        CONSENT_GIVEN_EVENT_NAME,
        this.handleConsentGiven,
      );
      window.addEventListener(LOGIN_POPUP_CLOSE, this.hideSignInBox);
      window.addEventListener('pageshow', event => {
        if (event.persisted) {
          this.checkUserStatus(false, this.loginInitCallback);
        }
      });
      // exposing SignIn and opensso function in window
      // used by Timespoints widgets to initiaite login on widget click
      // for Web
      window.TimesApps = window.TimesApps || {};
      window.TimesApps.SignIn = loginEventEmitter;
      // for mWeb
      this.addAppleLoginListener();
      window.opensso = method => {
        if (method === 'login') {
          loginEventEmitter();
        }
      };
    });

    // this.loadFBinit();
  }

  // loadFBinit = () => {
  //   if (typeof FB !== 'undefined') {
  //     FB.init({
  //       appId: 898459706886386,
  //       status: false,
  //       cookie: true,
  //       xfbml: false,
  //       version: 'v10.0',
  //     });
  //   }
  // };

  checkIfPrimeUser() {
    const prc = this.props.userData.prcValue || getPrcCookieValue();
    if (this.props.userData && !isPrimeNotActive(prc)) {
      this.setState({
        isPrimeUser: true,
      });
    }
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    const oldPrc = oldProps.userData.prcValue;
    const newPrc = newProps.userData.prcValue;
    const ssoid = Cookie.get('ssoid');
    if (
      typeof oldPrc !== 'undefined' &&
      typeof newPrc !== 'undefined' &&
      oldPrc !== newPrc
    ) {
      this.setPrimeStatus();
      if (
        window !== 'undefined' &&
        window.sessionStorage &&
        !window.sessionStorage.getItem('ampoffer')
      ) {
        const alterDataObject = {
          oldUserObjec: oldProps.userData,
          newUserObjec: newProps.userData,
        };
        alertLogger('PreLoggin', alterDataObject);

        this.refreshPage(newPrc, oldPrc);
      } else {
        sessionStorage.removeItem('ampoffer');
      }
    }

    if (
      newProps &&
      newProps.userData &&
      newProps.userData.isLoggedIn &&
      (!oldProps.userData ||
        (oldProps.userData && !oldProps.userData.isLoggedIn))
    ) {
      // for logged in users, show popup if consent is not already given
      this.handleUserConsentStatus();
      if (
        typeof window !== 'undefined' &&
        typeof window.FM !== 'undefined' &&
        typeof window.FM.identify === 'function'
      ) {
        FM.identify(ssoid);
      }
    }

    if (
      newProps &&
      newProps.userData &&
      newProps.userData.isLoggedIn &&
      newProps.userData.isLoggedIn !== oldProps.userData.isLoggedIn &&
      !this.props.userPrcData
    ) {
      this.props.getUserPrcData();
    }
    if (oldProps.userPrcData !== this.props.userPrcData) {
      checkGracePeriod(this.props.userPrcData).then(res => {
        this.setState({ inGracePeriod: res });
      });
      checkPreExpireDate(this.props.userPrcData).then(res => {
        this.setState({ isPreExpired: res });
      });
      const msid = getMsidFromPath(window.location.href);
      if (ssoid) {
        const primeCS =
          msid &&
          this.props.primeshow &&
          this.props.primeshow.data &&
          this.props.primeshow.data[msid] &&
          this.props.primeshow.data[msid].cs;
        setTimeout(() => {
          savingCallIfTimesPrime(
            this.props.isArticleshow,
            primeCS === 'prime',
            msid,
            this.props.userPrcData,
          );
        }, 3000);
      }
    }
  }

  refreshPage = (newPrc, oldPrc) => {
    const isUserLoggedIn = this.props.userData.isLoggedIn;
    // case when user is trying to login and user allowed to see prime content
    if (
      (isUserLoggedIn && ACTIVE_PRIME_USER_PRC_ARR.indexOf(newPrc) > -1) ||
      (!isUserLoggedIn && ACTIVE_PRIME_USER_PRC_ARR.indexOf(oldPrc) > -1)
    ) {
      if (isUserLoggedIn && isPrimeUser()) {
        setSessionStorage(ALREADY_PRIME_USER_STORAGE_NAME, 1);
      }
      const refreshEvent = new Event(LOGIN_PAGE_REFRESH);
      window.dispatchEvent(refreshEvent);
      if (!this.props.skipReloadForPrimeLogin) {
        if (!__PROD__) {
          reloadWrtPrimeUnlock();
        } else {
          window.location.reload(true);
        }
      }
    }
  };

  loginInitCallback = user => {
    // let userType = 'anon';
    if (user && typeof user === 'object') {
      const hashVal = window.location.hash.toLowerCase();
      if (hashVal === '#freetrialsuccess' || hashVal === '#success') {
        this.setPrcForUser(this.handlePrimeUserHashCase);
        // slice off the remaining '#' in HTML5:
        if (typeof window.history.replaceState === 'function') {
          window.history.replaceState(
            {},
            '',
            window.location.href.substr(0, window.location.href.indexOf('#')),
          );
        }
      }
      // if (isPrimeUser()) {
      //   userType = 'prime';
      // } else {
      //   userType = 'lgdin';
      // }

      const userAutoLoggedInEvent = new Event('user.autologgedin');
      this.setPrimeStatus();
      window.dispatchEvent(userAutoLoggedInEvent);
      this.callNativeAPI();
    } else {
      this.initOneTapLogin();
    }

    // if (window.TimesApps && window.TimesApps.chartbeatCall) {
    //   window.TimesApps.chartbeatCall.setloginType(userType);
    // }
  };

  callNativeAPI = () => {};

  handlePrimeUserHashCase = () => {
    this.updateUserPrcinRedux();
    this.initWelcomePrime(true, true);
  };

  //Setting prime staus to body to hide/ show some elements.
  setPrimeStatus = () => {
    const prcValue = getPrcCookieValue();
    if (prcValue > 0) {
      document.body.setAttribute('data-primestatus', prcValue);
    } else {
      document.body.removeAttribute('data-primestatus');
    }
    this.checkIfPrimeUser();
  };

  updateUserPrcinRedux = () => {
    this.props.storeUserData({
      prcValue: getPrcCookieValue(),
    });
  };

  setPrcForUser = callback => {
    if (!this.props.isMobile) {
      if (typeof window.JssoCrosswalk === 'undefined') {
        loadJssoCrossWalk(this.getValidLoggedInUser.bind(this, callback));
      } else {
        this.getValidLoggedInUser(callback);
      }
    } else {
      this.setCookiesAndGetUserInfo(callback);
    }
  };

  checkShowcaseUrl = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    return (
      Object.keys(params).length !== 0 && params.utm_source === 'newsshowcase'
    );
  };

  getJssoCrosswalkObj = () => {
    let jssoCrosswalkObj = '';
    if (typeof this.state.jssoCrosswalkObj === 'object') {
      jssoCrosswalkObj = this.state.jssoCrosswalkObj;
    } else if (typeof window.JssoCrosswalk === 'function') {
      jssoCrosswalkObj = !this.props.isMobile
        ? new window.JssoCrosswalk('toi', 'web')
        : new window.JssoCrosswalk('toi', 'WAP');
      this.setState({ jssoCrosswalkObj });
    }
    return jssoCrosswalkObj;
  };

  getValidLoggedInUser = callback => {
    const jssoObj = this.getJssoCrosswalkObj();
    jssoObj.getValidLoggedInUser(callback);
  };

  initOneTapLogin = (_event, callOneTapSignOnPriority, source) => {
    if (this.props.isPrivateUser && getGeoCountry() !== 'US') {
      return;
    }
    setTimeout(() => {
      const oneTapSignInEvent = new Event('onetapsignin');
      oneTapSignInEvent.customCallBack = this.checkUserStatus;
      oneTapSignInEvent.callOneTapSignOnPriority =
        callOneTapSignOnPriority || false;
      oneTapSignInEvent.source = source || '';
      oneTapSignInEvent.customFallbackFn = () => {
        this.oneTapLoginFallback(_event);
      };
      window.dispatchEvent(oneTapSignInEvent);
    }, 0);
  };

  oneTapLoginFallback = event => {
    if (!event) return;
    let isMobileOnlyLogin = false;
    let showAlternateLoginFn = null;

    this.loginEventDataObj = event.customDataObj;

    if (this.loginEventDataObj) {
      isMobileOnlyLogin = this.loginEventDataObj.isMobileOnlyLogin || false;
      showAlternateLoginFn = this.loginEventDataObj.showAlternateLogin || null;
    }

    if (typeof showAlternateLoginFn === 'function') {
      showAlternateLoginFn();
    } else {
      this.signInUser(event, isMobileOnlyLogin);
    }
  };

  initWelcomePrime = (isReloadRequired, showForce) => {
    if (this.props.isPrivateUser) {
      return;
    }
    setTimeout(() => {
      const primeWelcomePopEvent = new Event('primewelcomepopup');
      primeWelcomePopEvent.isReloadRequired = !!isReloadRequired;
      primeWelcomePopEvent.showForce = !!showForce;
      window.dispatchEvent(primeWelcomePopEvent);
    }, 0);
  };

  componentWillUnmount() {
    document.body.removeEventListener('keyup', this.closeModalOnEscapeKeyPress);
  }

  componentWillReceiveProps(nextData) {
    if (nextData && nextData.openLogin) {
      this.signInUser({}, nextData.loginType);
    }
  }

  hideSignInBox = () => {
    this.setState({ showSignIn: false });
    if (typeof this.props.showLoginModal !== 'undefined') {
      this.props.showLoginModal(false);
    }
    removeScroll();
    this.props.toggleLoginBox(false);
    if (typeof this.loginEventCallBack !== 'undefined') {
      delete this.loginEventCallBack;
    }
    if (typeof this.loginEventDataObj !== 'undefined') {
      delete this.loginEventDataObj;
    }
  };

  closeSignInModalOnOutsideClick = e => {
    if (e.srcElement && e.srcElement.id === 'login-popup') {
      this.hideSignInBox();
      this.handleNewsLetterConcent(true);
    }
  };

  closeModalOnEscapeKeyPress = e => {
    if (this.state.showSignIn) {
      const keyCode = e.keyCode || e.which;
      if (keyCode === 27) {
        this.hideSignInBox();
        this.handleNewsLetterConcent(true);
      }
    }
  };

  handleUserConsentStatus = () => {
    const jssoConsentCookie = Cookie.get('gdpr') || '';
    const jssoObj = this.getJssoCrosswalkObj();
    const isEUuser =
      (window.TimesGDPR.common &&
        window.TimesGDPR.common.consentModule &&
        window.TimesGDPR.common.consentModule.isEUuser()) ||
      false;

    // show consent popup if terms and shared data is not accepted
    if (jssoConsentCookie.indexOf('1#1#') !== 0) {
      this.props.storeUserData({
        showConsentPopUp: isEUuser,
      });
    } else {
      this.props.storeUserData({
        showConsentPopUp: false,
      });

      if (typeof jssoObj.updateUserPermissions === 'function') {
        // if user is in EU and has timepointpolicy not set to 0 (maybe earlier when user was in non EU), set timepointpolicy to 0
        if (this.props.isPrivateUser && jssoConsentCookie !== '1#1#0') {
          jssoObj.updateUserPermissions('1', '1', '0', () => {
            // to update gdpr cookie
            // jssoObj.getValidLoggedInUser();
          });
        }
        // if user is in non EU and has timepointpolicy not set to 1 (maybe earlier when user was in EU), set timepointpolicy to 1
        if (!this.props.isPrivateUser && jssoConsentCookie !== '1#1#1') {
          jssoObj.updateUserPermissions('1', '1', '1', () => {
            // to update gdpr cookie
            // jssoObj.getValidLoggedInUser();
          });
        }
      }
    }
  };

  handleLoginSuccessWithPollWidget = (siteEvent, category) => {
    gaCall(siteEvent);
    const tempga4EventTypeValue = getSessionStorage('ga4EventTypeValue') || '';
    const jssoObj = this.getJssoCrosswalkObj();
    jssoObj.getUserDetails(response => {
      const createdDateStr = response?.data?.createdDate;
      const createdDate = new Date(createdDateStr);
      const currentDate = new Date();

      analyticsWrapper('ga4', {
        event: 'user_login',
        type:
          tempga4EventTypeValue ||
          // eslint-disable-next-line no-nested-ternary
          (getSessionStorage('poll_widget_GA') || this.props.isMobile
            ? 'hamburger'
            : 'top_nav'),
        category,
        label: areDatesEqual(createdDate, currentDate) ? 'signup' : 'login',
      });
    });
    deleteSessionStorage('poll_widget_GA', 3000);
    deleteSessionStorage('ga4EventTypeValue', 3000);
  };

  setSSOInWindow = () => {
    window.onmessage = c => {
      if (
        c &&
        c.data &&
        c.data.type &&
        (c.data.type === 'loginSuccess' || c.data.type === 'loginFail')
      ) {
        const devUrl =
          document.domain.indexOf('timesofindia.com') >= 0
            ? 'https://spmdev.timesofindia.com'
            : 'https://toidev.indiatimes.com';
        const prodUrl =
          document.domain.indexOf('timesofindia.com') >= 0
            ? 'https://m.timesofindia.com'
            : 'https://timesofindia.indiatimes.com';
        const redirectDomain =
          __PROD__ || LOGIN_MAPPED_ON_LIVE ? prodUrl : devUrl;
        const data = { site: 'googleplus', status: '' };
        if (c.data.type === 'loginSuccess' && c.data.code) {
          const jssoObj = this.getJssoCrosswalkObj();
          if (typeof jssoObj.googleplusLogin === 'function') {
            const redirectUri = `${redirectDomain}/sso_v2.cms`;
            jssoObj.googleplusLogin(c.data.code, redirectUri, response => {
              if (response.status === 'SUCCESS') {
                data.status = 'signinsuccess';
                window.__sso(data);
              } else {
                window.__sso(data);
              }
            });
          }
        } else {
          window.__sso(data);
        }
      }
    };
    window.__sso = data => {
      if (data && (data.site === 'facebook' || data.site === 'googleplus')) {
        const isSignInSuccess =
          data.status === 'signinsuccess' || data.status === 'ssosigninsuccess';
        const fbOrGplusMappingUpdated = data.status === 'MappingUpdated';
        if (isSignInSuccess || fbOrGplusMappingUpdated) {
          const siteEvent =
            data.site === 'googleplus'
              ? 'Login_Success_Google'
              : 'Login_Success_FB';
          const category = data.site === 'googleplus' ? 'google' : 'facebook';
          this.handleLoginSuccessWithPollWidget(siteEvent, category);
          this.fbOrGoogleSignSuccessful = true;
        }
      }
      if (this.fbOrGoogleSignSuccessful) {
        this.checkUserStatus(false, this.subscribeNewsLettersAndAboundCallback);
      } else {
        this.checkUserStatus(false);
      }
    };
  };

  getUser = () => this.userList[this.config.single_user_id];

  setUser = (_user, result) => {
    const user = _user;
    if (typeof user !== 'undefined' && !isUser(user)) {
      throw new Error(
        "Object is not an instance of User, use 'getNewUser()' to get a User object.",
      );
    }

    this.userList[this.config.singleuser_id] = user;
    user.isLoggedIn = true;
    user.prcValue = getPrcCookieValue();
    user.isMobileOnlyLoggedInUser = true;
    if (this.registeredOrLogdInUserType) {
      user.registeredOrLogdInUserType = this.registeredOrLogdInUserType;
    }
    this.props.storeUserData(user);
    //this.props.setUserLoginStatus(true);
    let showSignIn = false;
    const { isPrimePaymentFlow } = this.loginEventDataObj || {};
    if (
      isPrimePaymentFlow &&
      (typeof user.prcValue === 'undefined' ||
        user.prcValue === PRC_FOR_NEVER_REGISTER)
    ) {
      showSignIn = true;
    }
    const userPhone = window.userPhone || result.M_N;
    if (userPhone) {
      sessionStorage.setItem('userPhone', userPhone);
    }
    if (typeof this.props.showLoginModal !== 'undefined') {
      this.props.showLoginModal(showSignIn);
    }
    this.setState({
      showSignIn,
      // user: user,
      loggedIn: true,
      firstName: _user.getFirstName(),
      email: _user.getEmail(),
      thumbImg: _user.getThumb(),
    });
    if (this.fbOrGoogleSignSuccessful || window.MobOrEmailloginSuccessful) {
      const __ssoid =
        typeof document !== 'undefined' &&
        document.cookie.match(/(?:\s)?ssoid=(\w+);?/);
      analyticsWrapper('grx', 'userId', !!__ssoid && __ssoid[1]);
      analyticsWrapper('grx', 'track', 'login', {
        email: window.userPhone ? '' : _user.getEmail(),
        phone: window.userPhone || result.M_N,
        url: window.location.href,
        keywords: window.seoMetaKeywords,
        source: window.loginSource,
      });
      window.loginSource = '';
      this.fbOrGoogleSignSuccessful = false;
      window.MobOrEmailloginSuccessful = false;
    }
    removeScroll();
  };

  setRgTimeForEAandPrimeUserInfo = (crosswalkUserData, callback) => {
    if (crosswalkUserData && crosswalkUserData.createdDate !== '') {
      const cname = 'rgtime';
      const cvalue = new Date(crosswalkUserData.createdDate).getTime() / 1000;
      Cookie.set(cname, cvalue, 10);
    }
    if (crosswalkUserData) {
      this.getPrimeUserInfo(crosswalkUserData);
    } else {
      localStorage.setItem('dmpStorage', JSON.stringify({ userType: 'Free' }));
      this.props.storeUserData({
        showConsentPopUp: false,
        isLoggedIn: false,
        prcValue: getPrcCookieValue(),
      });
    }

    if (typeof callback === 'function') {
      callback(
        (crosswalkUserData &&
          Array.isArray(crosswalkUserData) &&
          crosswalkUserData[0]) ||
          crosswalkUserData,
      );
    }
    if (typeof this.loginEventCallBack === 'function') {
      this.loginEventCallBack(
        (crosswalkUserData &&
          Array.isArray(crosswalkUserData) &&
          crosswalkUserData[0]) ||
          crosswalkUserData,
      );
      delete this.loginEventCallBack;
    }
  };

  subscribeNewsLettersAndAboundCallback = userDataToSubscribe => {
    if (
      this.props.userData &&
      this.props.userData?.isLoggedIn &&
      this.props.loadAboundPoints &&
      typeof window !== 'undefined' &&
      typeof window.geoinfo.CountryCode === 'string' &&
      window.geoinfo.CountryCode === 'US' &&
      ((this.props.userData?.getMobile()?.Verified?.mobile &&
        this.props.userData?.getMobile()?.Verified?.code === '+1') ||
        this.props.userData?.getEmail())
    ) {
      const ssoId =
        this.props.userData.getUid() ||
        Cookie.get('ssoid') ||
        Cookie.get('ssoId');
      if (typeof this.props.loadAboundPoints === 'function') {
        setSessionStorage('ga4EventTypeValue', 'abound');
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: `login_proceed_${
            this.props.isAboundSignupChecked ? 'with' : 'without'
          }_consent`,
          category: 'abound',
        });
        this.props.loadAboundPoints({
          ssoid: ssoId,
          phoneNumber: this.props.userData?.getMobile()?.Verified?.mobile,
          email: this.props.userData?.getEmail(),
          signup: this.props.isAboundSignupChecked,
        });
      }
    }

    if (
      userDataToSubscribe &&
      this.state.newsLetterSubscription &&
      userDataToSubscribe.emailList
    ) {
      let subsFlag = false;
      let userEmail;
      // eslint-disable-next-line no-restricted-syntax
      for (const email in userDataToSubscribe.emailList) {
        if (userDataToSubscribe.emailList[email] === 'Verified') {
          subsFlag = true;
          userEmail = email;
        }
      }
      let source = 'TOI_Desktop';
      if (subsFlag) {
        if (
          this.props.isMobile &&
          typeof window !== 'undefined' &&
          window.location.href.match(
            '/entertainment/|/tv/|/life-style/|/web-series/',
          )
        ) {
          source = 'Etimes_Mweb';
        } else if (
          !this.props.isMobile &&
          typeof window !== 'undefined' &&
          window.location.href.match(
            '/entertainment/|/tv/|/life-style/|/web-series/',
          )
        ) {
          source = 'Etimes_Desktop';
        } else if (this.props.isMobile) {
          source = 'TOI_Mweb';
        }
        const postData = {
          userId: userEmail,
          ssoCheck: true,
          isloginSignup: true,
          preferenceSubscriptions: NEWSLETTER_DEFAULT_VAL,
        };
        makeRequest.post(NEWSLETTER_SUBSCRIPTION_API, postData).then(() => {
          console.log('Newsletters has been Subscribed');
        });
      }
    }
  };

  subscribeAndSignupAbound = () => {
    if (
      this.props.userData &&
      this.props.userData?.isLoggedIn &&
      this.props.loadAboundPoints &&
      typeof window !== 'undefined' &&
      window.geoinfo &&
      typeof window.geoinfo.CountryCode === 'string' &&
      window.geoinfo.CountryCode === 'US' &&
      ((this.props.userData?.getMobile()?.Verified?.mobile &&
        this.props.userData?.getMobile()?.Verified?.code === '+1') ||
        this.props.userData?.getEmail())
    ) {
      const ssoId =
        this.props.userData.getUid() ||
        Cookie.get('ssoid') ||
        Cookie.get('ssoId');
      if (typeof this.props.loadAboundPoints === 'function') {
        this.props.loadAboundPoints({
          ssoid: ssoId,
          phoneNumber: this.props.userData?.getMobile()?.Verified?.mobile,
          email: this.props.userData?.getEmail(),
          signup: true,
        });
      }
    }
  };

  handleNewsLetterConcent = (value = null) => {
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      window.geoinfo.CountryCode &&
      typeof window.geoinfo.CountryCode === 'string' &&
      window.geoinfo.CountryCode !== 'US'
    ) {
      this.setState({
        newsLetterSubscription:
          value == null ? !this.state.newsLetterSubscription : value,
      });
    }
  };

  getUsersInfo = (ssoId, callback) => {
    this.getCrsossWalkGetUserDetails(
      this.setRgTimeForEAandPrimeUserInfo,
      callback,
    );
  };

  getPrimeUserInfo = fetchedUser => {
    this.isLoggedIn(
      (Array.isArray(fetchedUser) && fetchedUser.length && fetchedUser[0]) ||
        fetchedUser,
    );
  };
  iframe = src => {
    const i = document.createElement('iframe');
    i.src = src;
    i.scrolling = 'no';
    i.frameBorder = '0';
    i.width = 0;
    i.height = 0;
    i.title = 'The Times of India';
    document.body.appendChild(i);
    return i;
  };

  loginEventFn = (changeTransform = null, event) => {
    let isMobileOnlyLogin = false;
    let callOneTapSignOnPriority = false;
    let source = '';
    let showAlternateLoginFn = null;

    this.loginEventCallBack = event.customCallBack;
    this.loginEventDataObj = event.customDataObj;
    this.numberToPrefill = event.numberToPrefill;

    if (this.loginEventDataObj) {
      isMobileOnlyLogin = this.loginEventDataObj.isMobileOnlyLogin || false;
      callOneTapSignOnPriority =
        this.loginEventDataObj.callOneTapSignOnPriority || false;
      source = this.loginEventDataObj.source || '';
      showAlternateLoginFn = this.loginEventDataObj.showAlternateLogin || null;
      this.showToiSubscriptionText =
        this.loginEventDataObj.showToiSubscriptionText || false;
    }
    this.showLogoutToastMsg = window.showLogoutToastMsg || false;

    if (callOneTapSignOnPriority === true) {
      this.initOneTapLogin(event, callOneTapSignOnPriority, source);
    } else if (typeof showAlternateLoginFn === 'function') {
      showAlternateLoginFn();
    } else {
      this.signInUser(event, isMobileOnlyLogin);
    }
    if (typeof changeTransform === 'function') changeTransform();
  };

  logoutCrossWalk = () => {
    const jssoCrosswalkObj = !this.props.isMobile
      ? new window.JssoCrosswalk('toi', 'web')
      : new window.JssoCrosswalk('toi', 'WAP');
    jssoCrosswalkObj.signOutUser();
    try {
      if (
        typeof google !== 'undefined' &&
        typeof google.accounts.id.disableAutoSelect === 'function'
      ) {
        google.accounts.id.disableAutoSelect();
      }
    } catch (error) {
      console.log('google accounts disableAutoSelect', error);
    }
  };
  removeUser = () => {
    delete this.userList[this.config.single_user_id];
    localStorage.setItem('dmpStorage', JSON.stringify({ userType: 'Free' }));
    this.props.storeUserData({
      isLoggedIn: false,
      prcValue: getPrcCookieValue(),
    });
    if (typeof this.props.showLoginModal !== 'undefined') {
      this.props.showLoginModal(false);
    }
    this.setState({
      showSignIn: false,
      loggedIn: false,
      firstName: '',
      thumbImg: '',
    });
  };
  logout = event => {
    const alterDataObjectBefore = {
      userObject: this.props.userData,
    };
    alertLogger('PreLoggout', alterDataObjectBefore);

    //const isPrimeUserBeforeLogout = isPrimeUser();
    analyticsWrapper(
      'gaAndGrx',
      'send',
      'event',
      `WEB-${window.location.href}`,
      'Header-User_Profile',
      'Click-Logout-3',
    );
    if (window.sessionStorage) {
      sessionStorage.removeItem('jsso_crosswalk_user_details');
      sessionStorage.removeItem('planName');
      sessionStorage.removeItem('userPhone');
    }
    if (window.localStorage) {
      localStorage.removeItem('timesHealthStripClosedAtTOIPHome');
      localStorage.removeItem('timesHealthStripClosedAtTOIArticleShow');
      localStorage.removeItem('timesHealthStripClosedAtPrimeHome');
      localStorage.removeItem('timesHealthStripClosedAtTOIArticleShowNonPrime');
    }
    // handing GA4 events special case
    sessionStorage.setItem('isUserLoggedOut', 1);
    this.removeUser();
    // const logoutUrl = `${
    //   this.api_urls.jsso
    // }/sso/identity/profile/logout/external?channel=${this.channel}`;
    // const ifr = this.iframe(logoutUrl);
    // ifr.onload = () => {
    //   ifr.parentElement.removeChild(ifr);
    //   if (window.__sso) {
    //     window.__sso();
    //   }
    // };

    if (typeof localStorage === 'object') {
      try {
        localStorage.removeItem('sso_user');
        localStorage.removeItem('planName');
        localStorage.removeItem('cred_access_token');
        localStorage.removeItem('paidStoryArrAlreadyOpenedPopup');
        localStorage.removeItem('renewNudgeCloseTime');
        localStorage.removeItem('pollSelections');
        localStorage.setItem(
          'dmpStorage',
          JSON.stringify({ userType: 'Free' }),
        );
      } catch (e) {
        // console.log('local storage not available');
      }
    }

    const domain = this.props.isMobileState
      ? 'timesofindia.com'
      : 'indiatimes.com';

    if (typeof window.JssoCrosswalk === 'undefined') {
      loadJssoCrossWalk(this.logoutCrossWalk);
    } else {
      this.logoutCrossWalk();
    }
    Cookie.remove('ssoid', '/', domain);
    Cookie.remove('Fbsecuritykey', '/', domain);
    Cookie.remove('fbookname', '/', domain);
    Cookie.remove('CommLogP', '/', domain);
    Cookie.remove('CommLogU', '/', domain);
    Cookie.remove('FaceBookEmail', '/', domain);
    Cookie.remove('Fbimage', '/', domain);
    Cookie.remove('fbooklocation', '/', domain);
    Cookie.remove('Fboauthid', '/', domain);
    Cookie.remove('fbname', '/', domain);
    Cookie.remove('fbLocation', '/', domain);
    Cookie.remove('fbimage', '/', domain);
    Cookie.remove('fbOAuthId', '/', domain);
    Cookie.remove('MSCSAuth', '/', domain);
    Cookie.remove('MSCSAuthDetail', '/', domain);
    Cookie.remove('MSCSAuthDetails', '/', domain);
    Cookie.remove('Twimage', '/', domain);
    Cookie.remove('TwitterUserName', '/', domain);
    Cookie.remove('Fboauthid', '/', domain);
    Cookie.remove('Twoauthid', '/', domain);
    Cookie.remove('Twsecuritykey', '/', domain);
    Cookie.remove('ssosigninsuccess', '/', domain);
    Cookie.remove('prc', '/', domain);
    Cookie.remove('ipr', '/', domain);
    Cookie.remove('gdpr', '/', domain);
    Cookie.remove('ssoid');
    Cookie.remove('MSCSAuthDetail');
    Cookie.remove('articleid');
    Cookie.remove('txtmsg');
    Cookie.remove('tflocation');
    Cookie.remove('tfemail');
    Cookie.remove('setfocus');
    Cookie.remove('fbookname');
    Cookie.remove('CommLogP');
    Cookie.remove('CommLogU');
    Cookie.remove('FaceBookEmail');
    Cookie.remove('Fbimage');
    Cookie.remove('fbooklocation');
    Cookie.remove('Fboauthid');
    Cookie.remove('Fbsecuritykey');
    Cookie.remove('fbname');
    Cookie.remove('fbLocation');
    Cookie.remove('fbimage');
    Cookie.remove('fbOAuthId');
    Cookie.remove('MSCSAuth');
    Cookie.remove('MSCSAuthDetail');
    Cookie.remove('MSCSAuthDetails');
    Cookie.remove('ssosigninsuccess');
    Cookie.remove('Twimage');
    Cookie.remove('TwitterUserName');
    Cookie.remove('Twoauthid');
    Cookie.remove('Twsecuritykey');
    Cookie.remove('prc');
    Cookie.remove('ipr');
    Cookie.remove('gdpr');
    Cookie.remove('rgtime', '/', domain);
    Cookie.remove('rgtime');
    Cookie.remove('aboundToken', '/');
    const jssoObj = this.getJssoCrosswalkObj();
    if (typeof jssoObj.signOutUser === 'function') {
      jssoObj.signOutUser();
    }

    const alterDataObject = {
      userObjectPRC: this.props.userData?.prcValue,
    };
    alertLogger('PostLoggout', alterDataObject);

    this.props.storeUserData({
      isLoggedIn: false,
      prcValue: getPrcCookieValue(),
      showConsentPopUp: false,
    });

    this.handleNewsLetterConcent(true);

    // This is require , apart from state, if we are calling it from event chain then callback should resolve.
    if (
      event &&
      event.customCallBack &&
      typeof event.customCallBack === 'function'
    ) {
      event.customCallBack();
    }

    // if (isPrimeUserBeforeLogout) {
    //   window.location.reload(true);
    // }
  };

  handleConsentGiven = () => {
    this.props.storeUserData({
      showConsentPopUp: false,
    });
  };

  signInUser = (event, isMobileOnlyLogin) => {
    if (this.state.showSignIn || this.props.userData.isLoggedIn) {
      return;
    }
    if (event && Object.keys(event).length === 0) {
      this.showToiSubscriptionText = false;
    }
    /*below line can be deleted and no need to pass argument.
    Condition would be false automatically,  if it is undefined
    Need to confirm with @Anurag*/
    this.isMobileOnlyLogin = isMobileOnlyLogin;
    this.setState({ showSignIn: true });
    if (typeof this.props.showLoginModal !== 'undefined') {
      this.props.showLoginModal(true);
    }
    addScroll();
    gaCall('Load');
    //deleteSessionStorage('poll_widget_GA');
  };

  checkUserStatus = (doNotClose, callback, registeredOrLogdInUserType) => {
    if (registeredOrLogdInUserType) {
      this.registeredOrLogdInUserType = registeredOrLogdInUserType;
    }
    this.setState({ doNotClose: !!doNotClose });
    let ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    const ticketId = Cookie.get('TicketId') || Cookie.get('TicketId');
    const MSCSAuthDetails = Cookie.get('MSCSAuthDetails');
    if (!ssoid && MSCSAuthDetails) {
      ssoid = MSCSAuthDetails.split('=')[1];
    }
    // if (ssoid && ssoid.length > 0) {
    this.props.toggleLoginBox(false);
    // if (!ssoid) {
    //   if (callback) {
    //     callback(null);
    //   }
    //   return;
    // }
    const isLoggedInUser = this.getUser();
    if (isLoggedInUser) {
      if (callback) {
        callback(isLoggedInUser);
      }
    } else if (MSCSAuthDetails) {
      // old cookie is set
      this.getUsersInfo(ssoid, callback);
    } else {
      // set server cookie
      this.setCookiesAndGetUserInfo(callback);
    }
  };

  getTicketCallback = (ticketId, ssoid, callback) => {
    if (ticketId) {
      // const socialappurl =
      //   document.domain.indexOf('timesofindia.com') >= 0
      //     ? `//${
      //         window.location.hostname
      //       }/v1validateTicket?ticketId=${ticketId}&channel=${this.channel}`
      //     : `${
      //         this.api_urls.socialappsintegrator
      //       }/socialsite/v1validateTicket?ticketId=${ticketId}&channel=${
      //         this.channel
      //       }`;
      // set old cookies
      // jsonp(socialappurl, null, () => {
      //   if (window.location.hostname.indexOf('.indiatimes.com') > -1) {
      //     this.getUsersInfo(ssoid, callback);
      //   } else {
      //     jsonp(socialappurl, null, () => {
      //       this.getUsersInfo(ssoid, callback);
      //     });
      //   }
      //   // let API =
      //   //   window.location.hostname.indexOf('.indiatimes.com') > -1
      //   //     ? PRC_PRIME_API_DESKTOP
      //   //     : PRC_PRIME_API_MOB;
      //   // const rnd = Math.random();
      //   // API += `?rnd=${rnd}`;
      //   // makeRequest.get(API, {
      //   //   withCredentials: true,
      //   // });
      // });
      this.getUsersInfo(ssoid, callback);
    } else {
      if (callback) {
        callback(null);
      }
      localStorage.setItem('dmpStorage', JSON.stringify({ userType: 'Free' }));
      this.props.storeUserData({
        showConsentPopUp: false,
        isLoggedIn: false,
        prcValue: getPrcCookieValue(),
      });
    }
  };

  setCookiesAndGetUserInfo = callback => {
    const trackIdParam = getQueryParams('ticketId');
    const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (sessionStorage.getItem('isUserLoggedOut') !== null) {
        sessionStorage.removeItem('isUserLoggedOut');
      }
    }
    if (trackIdParam) {
      this.loadJssoV1ValidLoggedInUser(trackIdParam, () => {
        this.getTicketCallback(trackIdParam, ssoid, callback);
      });
    } else {
      this.getTicket(data => {
        const ticketId = data && data.encTicket ? data.encTicket : false;
        this.getTicketCallback(ticketId, ssoid, callback);
      });
    }
  };

  loadJssoV1ValidLoggedInUserFn = (ticketId, callback) => {
    const jssoObj = this.getJssoCrosswalkObj();
    if (typeof jssoObj.getV1ValidLoggedInUser === 'function') {
      jssoObj.getV1ValidLoggedInUser(ticketId, false, response => {
        if (
          parseInt(response.code, 10) === 200 &&
          typeof callback === 'function'
        ) {
          callback(response.data);
        } else if (typeof callback === 'function') {
          callback(null);
        }
      });
    }
  };

  loadJssoV1ValidLoggedInUser = (ticketId, callback) => {
    if (typeof window.JssoCrosswalk === 'undefined') {
      loadJssoCrossWalk(
        this.loadJssoV1ValidLoggedInUserFn.bind(this, ticketId, callback),
      );
    } else {
      this.loadJssoV1ValidLoggedInUserFn(ticketId, callback);
    }
  };

  getTicket = callback => {
    if (typeof window.JssoCrosswalk === 'undefined') {
      loadJssoCrossWalk(this.getCrsossWalkLogginUser.bind(this, callback));
    } else {
      this.getCrsossWalkLogginUser(callback);
    }
  };

  getCrsossWalkLogginUser = callback => {
    const jssoObj = this.getJssoCrosswalkObj();
    if (typeof jssoObj.getValidLoggedInUser === 'function') {
      jssoObj.getValidLoggedInUser(response => {
        if (
          parseInt(response.code, 10) === 200 &&
          typeof callback === 'function'
        ) {
          callback(response.data);
        } else if (typeof callback === 'function') {
          callback(null);
        }
      });
    }
  };

  getCrsossWalkGetUserDetails = (callback, callback2) => {
    const jssoObj = this.getJssoCrosswalkObj();
    if (typeof jssoObj.getUserDetails === 'function') {
      jssoObj.getUserDetails(response => {
        if (
          parseInt(response.code, 10) === 200 &&
          typeof callback === 'function'
        ) {
          callback(response.data, callback2);
        } else if (typeof callback === 'function') {
          callback(null, callback2);
        }
      });
    }
  };

  hashandshareCookie = (_user, result) => {
    try {
      if (_user && typeof window !== 'undefined' && window._dfpObj?.hash) {
        const email = _user.getEmail();
        let ph;
        let mcode = '';
        if (result?.mobileData?.Verified) {
          const { mobile, code } = result.mobileData.Verified || {};
          ph = mobile;
          mcode = code;
        }
        if (email) {
          window._dfpObj.hash('email', email);
        }
        if (ph) {
          window._dfpObj.hash('phone', ph, mcode);
        }
      }
    } catch (error) {
      //
    }
  };

  isLoggedIn = result => {
    result = {
      ...result,
      ticketId: Cookie.get('TicketId') || Cookie.get('ticketId'),
    };
    const _user = getNewUser(result);
    this.hashandshareCookie(_user, result);
    if (_user) {
      _user.loginType = Cookie.get('LoginType');
      _user.facebook = {
        name: Cookie.get('fbookname'),
        location: Cookie.get('fbooklocation'),
        image: Cookie.get('Fbimage'),
        email: Cookie.get('FaceBookEmail'),
        oauth: Cookie.get('Fboauthid'),
      };
      _user.twitter = {
        name: Cookie.get('TwitterUserName'),
        image: Cookie.get('Twimage'),
        oauth: Cookie.get('Twoauthid'),
      };
      this.setUser(_user, result);
    } else {
      localStorage.setItem('dmpStorage', JSON.stringify({ userType: 'Free' }));
      this.props.storeUserData({
        showConsentPopUp: false,
        isLoggedIn: false,
        prcValue: getPrcCookieValue(),
      });
      this.removeUser();
    }
  };

  closeSignInPopUp = (e, screenName) => {
    this.state.doNotClose = false;
    this.hideSignInBox();
    this.handleNewsLetterConcent(true);
    gaCall('Close', screenName);
  };

  loginWithFacebook = () => {
    gaCall('Click_FB');
    loadFacebookJs(() => {
      if (typeof FB !== 'undefined') {
        FB.login(
          data => {
            if (data.authResponse) {
              const jssoObj = this.getJssoCrosswalkObj();
              const token = data.authResponse.signedRequest.split('.')[1];
              const jsonToken = JSON.parse(atob(token));
              const appCode = jsonToken.code;
              if (typeof jssoObj.facebookLogin === 'function') {
                jssoObj.facebookLogin(appCode, '', res => {
                  if (res.status === 'SUCCESS') {
                    window.__sso({ site: 'facebook', status: 'signinsuccess' });
                  } else {
                    try {
                      FB.logout();
                    } catch (h) {
                      console.info(h);
                    }
                  }
                });
              }
            } else {
              console.log('User cancelled login or did not fully authorize.');
            }
          },
          {
            scope: 'email',
          },
        );
      }
    });
  };

  loginWithGoogle = (clientId, gisToken) => {
    const jssoObj = this.getJssoCrosswalkObj();
    if (gisToken && typeof jssoObj.GisLogin === 'function' && clientId) {
      jssoObj.GisLogin(clientId, gisToken, 'btn', null, () => {
        this.handleLoginSuccessWithPollWidget('Login_Success_Google', 'google');
        this.checkUserStatus(false, this.subscribeNewsLettersAndAboundCallback);
      });
    }
    gaCall('Click_Google');
  };

  loginWithGoogleFedcm = event => {
    const { gisToken, clientId } = event;
    this.loginWithGoogle(clientId, gisToken);
  };

  loginWithGoogleOld = () => {
    const devUrl =
      document.domain.indexOf('timesofindia.com') >= 0
        ? 'https://spmdev.timesofindia.com'
        : 'https://toidev.indiatimes.com';
    const prodUrl =
      document.domain.indexOf('timesofindia.com') >= 0
        ? 'https://m.timesofindia.com'
        : 'https://timesofindia.indiatimes.com';
    const redirectDomain = __PROD__ || LOGIN_MAPPED_ON_LIVE ? prodUrl : devUrl;
    const loginUrl = `https://accounts.google.com/signin/oauth/oauthchooseaccount?client_id=103703403489-b4t4lt8mr05brqpcdrmsu0di54cmjv4f.apps.googleusercontent.com&scope=email&redirect_uri=${redirectDomain}/sso_v2.cms&response_type=code`;
    this.popUpOpener(loginUrl);
    gaCall('Click_Google');
  };

  popUpOpener = (url, callback) => {
    const loginWindow = this.openPopUp(
      url,
      {
        width: 850,
        height: 780,
        scrollbars: 0,
      },
      result => {
        if (result && result.code === '200') {
          this.checkUserStatus();
        } else if (callback) {
          callback(null, result);
        }
      },
    );
    if (loginWindow) loginWindow.moveTo(315, 250);
  };
  openPopUp = (url, options) => {
    const defaultOptions = {
      width: 300,
      height: 300,
      name: 'Window',
      mask: true,
      resizable: false,
      disableScroll: false,
      closeCallback() {},
    };
    const opt = Object.assign({}, defaultOptions, options);
    const x = window.screen.width / 2 - opt.width / 2;
    const y = window.screen.height / 2 - opt.height / 2;
    const params = [
      `width=${opt.width}`,
      `height=${opt.height}`,
      `left=${typeof opt.left !== 'undefined' ? opt.left : x}`,
      `top=${typeof opt.top !== 'undefined' ? opt.top : y - 20}`,
      `scrollbars=${
        typeof opt.scrollbars !== 'undefined' && opt.scrollbars === 1
          ? opt.scrollbars
          : 0
      }`,
      `resizable=${opt.resizable}`,
    ];
    const popup = window.open(url, opt.name, params.join(','));
    if (popup) {
      popup.focus();
    }
    try {
      // Exception "Permission Denied" in IE, using try catch so that this functionality works in other browsers.
      popup.reposition = () => {
        popup.moveTo(x, y);
      };
    } catch (e) {
      //
    }
    if (!popup) {
      // alert('Popups are blocked. Please enable them.'); // TODO find better way
      return popup;
    }
    return popup;
  };
  close = name => {
    if (!name) {
      return;
    }
    const popup = this.open_window[name];
    if (popup) {
      window.clearInterval(popup.interval);
      popup.interval = null;
      popup.popup.close();
      this.open_window[popup.opt.name] = null;
      popup.opt.closeCallback(popup.popup);
    }
  };

  addAppleLoginListener = () => {
    if (
      typeof window !== 'undefined' &&
      typeof window.BroadcastChannel === 'function'
    ) {
      const channel = new BroadcastChannel(this.channel);

      channel.onmessage = event => {
        const { sender, message } = event.data;
        if (sender === 'applelogin') {
          this.checkUserStatus(
            false,
            this.subscribeNewsLettersAndAboundCallback,
          );
          const siteEvent = 'Login_Success_Apple';
          const category = 'apple';
          this.handleLoginSuccessWithPollWidget(siteEvent, category);
        }
      };
    } else {
      window.addEventListener(
        'message',
        event => {
          const { sender, message } = event.data || {};
          if (sender === 'applelogin') {
            this.checkUserStatus(
              false,
              this.subscribeNewsLettersAndAboundCallback,
            );
            const siteEvent = 'Login_Success_Apple';
            const category = 'apple';
            this.handleLoginSuccessWithPollWidget(siteEvent, category);
          }
        },
        false,
      );
    }
  };

  loginWithApple = () => {
    const jssoObj = this.getJssoCrosswalkObj();
    if (jssoObj && typeof jssoObj?.socialLogin === 'function') {
      jssoObj.socialLogin(
        'APPLE',
        'com.timesofindia.login',
        'https://jsso.indiatimes.com/sso/identity/login/appleLogin',
        `https://${window.location.host}/login_code_v2.cms?device=${
          this.props.isMobile ? 'WAP' : 'web'
        }`,
      );
    }

    gaCall('Click_Apple');
  };

  loginWithCred = event => {
    const tokenData =
      localStorage.getItem('cred_access_token') &&
      JSON.parse(localStorage.getItem('cred_access_token'));
    const jssoObj = this.getJssoCrosswalkObj();
    jssoObj.credLogin(tokenData?.access_token, response => {
      //Promise.resolve(dataResponse).then(response => {
      if (parseInt(response.code, 10) === 200) {
        if (response?.data?.loginIdentifierType === 'mobile') {
          sessionStorage.setItem('userPhone', response?.data?.identifier);
        }
        this.checkUserStatus(false, event?.customCallBack);
      } else if (response.status === 'FAILURE') {
        localStorage.setItem(
          'cred_login_failure',
          JSON.stringify('cred_login_failure'),
        );
        window.location.reload();
      }
    });
  };

  render() {
    const {
      userPointsData,
      allActivity,
      toipLayout,
      headerNudges,
      isMobileState,
      userPrcData,
    } = this.props;
    const isTimespointAvailable =
      // this.state.loggedIn &&
      userPointsData && this.state.isMobile && this.props.isVisible;
    const userTimesPoint = isTimespointAvailable
      ? parseInt(userPointsData.points || 0, 10)
      : 0;
    const divClass = isTimespointAvailable ? 'padtop2' : '';
    if (this.props.focusNavigation) {
      this.props.focusNavigation(this.state.showSignIn);
    }
    // let run only for prime user flow case.
    const { isPrimePaymentFlow, isOnlySubscribe } =
      this.loginEventDataObj || {};
    if (isPrimePaymentFlow) {
      this.freeTrialTpPoints = getUserTimesPointByPRC(
        isMobileState,
        allActivity,
      );
    }
    if (isOnlySubscribe) {
      this.freeTrialTpPoints = getUserTimesPaidPoints(
        isMobileState,
        allActivity,
      );
    }
    return (
      <>
        {!this.props.isMobile &&
          !this.props.toipLayout && (
            <OnetapsigninV2
              username={this.state.email}
              isWapView={this.props.isMobile}
            />
          )}
        <AboundSignUpPopup
          username={this.state.email}
          isWapView={this.props.isMobile}
          loginUserCallback={this.checkUserStatus}
          getJssoCrosswalkObj={this.getJssoCrosswalkObj}
          logout={this.logout}
        />
        <AboundSignUpPopupLoggedIn
          username={this.state.email}
          isWapView={this.props.isMobile}
          loginUserCallback={this.checkUserStatus}
          getJssoCrosswalkObj={this.getJssoCrosswalkObj}
          logout={this.logout}
          subscribeAndSignupAbound={this.subscribeAndSignupAbound}
        />
        <AboundSDK
          signInUser={this.signInUser}
          toggleLoginBox={this.props.toggleLoginBox}
          isWapView={this.props.isMobile}
        />
        {this.state.jssoCrosswalkObj && (
          <TrueCallerLogin
            username={this.state.email}
            isWapView={this.props.isMobile}
            jssoObj={this.state.jssoCrosswalkObj}
            loginUserCallback={this.checkUserStatus}
          />
        )}
        {!this.state.isMobile &&
          this.props.isPrime &&
          !this.state.inGracePeriod &&
          !this.state.isPreExpired && <div id="widget-head" />}
        {/* <div
          className={`${
            this.props.pageType === 'ARTICLESHOW' ||
            this.props.pageType === 'LIVEBLOG' ||
            this.props.pageType === 'Home'
              ? 'login_fix'
              : ''
          } user_area clearfix ${
            this.props.isVisible || this.state.showSignIn ? '' : 'hide'
          } ${this.props.theme || ''}`}
        > */}

        <div
          className={`login_fix user_area clearfix ${
            this.props.isEtimes ? 'etimes' : ''
          } ${
            this.props.isVisible || this.state.showSignIn ? '' : 'hide'
          } ${this.props.theme || ''}`}
        >
          <div className={`${divClass}`}>
            <PopupPortal
              wrapper=".signup-popup-overlay"
              usePopupPortal={typeof window !== 'undefined'}
            >
              <div
                id="login-popup"
                className={
                  this.state.showSignIn || this.state.doNotClose ? 'active' : ''
                }
              >
                {this.isMobileOnlyLogin
                  ? (this.state.showSignIn || this.state.doNotClose) && (
                      <MobileOnlySignInLoader
                        loginUserCallback={this.checkUserStatus}
                        showSignIn={
                          this.state.showSignIn || this.state.doNotClose
                        }
                        closeSignInPopUp={this.closeSignInPopUp}
                        isPrivateUser={this.props.isPrivateUser}
                        isMobile={this.props.isMobile}
                        isOnlySubscribe={isOnlySubscribe}
                        loginWithFacebook={this.loginWithFacebook}
                        loginWithGoogle={this.loginWithGoogle}
                        getJssoCrosswalkObj={this.getJssoCrosswalkObj}
                        logout={this.logout}
                        freeTrialTpPoints={this.freeTrialTpPoints}
                        userEmailid={this.props.userEmailid}
                      />
                    )
                  : (this.state.showSignIn || this.state.doNotClose) && (
                      <SignInLoader
                        loginUserCallback={this.checkUserStatus}
                        showSignIn={
                          this.state.showSignIn || this.state.doNotClose
                        }
                        newsLetterSubscription={
                          this.state.newsLetterSubscription
                        }
                        handleNewsLetterConcent={this.handleNewsLetterConcent}
                        subscribeNewsLettersAndAboundCallback={
                          this.subscribeNewsLettersAndAboundCallback
                        }
                        closeSignInPopUp={this.closeSignInPopUp}
                        isPrivateUser={this.props.isPrivateUser}
                        isMobile={this.props.isMobile}
                        loginWithFacebook={this.loginWithFacebook}
                        loginWithGoogle={this.loginWithGoogle}
                        loginWithApple={this.loginWithApple}
                        getJssoCrosswalkObj={this.getJssoCrosswalkObj}
                        logout={this.logout}
                        showToiSubscriptionText={this.showToiSubscriptionText}
                        showLogoutToastMsg={this.showLogoutToastMsg}
                        onChangeTransform={this.props.onChangeTransform}
                        preFill={this.numberToPrefill}
                        userEmailid={this.props.userEmailid}
                      />
                    )}
              </div>
            </PopupPortal>

            {this.state.loggedIn &&
              !this.state.isMobile &&
              !this.props.isDefencePage && (
                <LoggedInUser
                  firstName={this.state.firstName}
                  isPrimeUser={this.state.isPrimeUser}
                  isMobile={this.state.isMobile}
                  logout={this.logout}
                  theme={this.props.theme || ''}
                  thumbImg={
                    this.state.thumbImg ||
                    'https://mytimes.indiatimes.com/image/thumb/0/default'
                  }
                  userData={this.props.userData}
                  pageType={this.props.pageType}
                  toipLayout={toipLayout}
                  headerNudges={headerNudges}
                  userPrcData={userPrcData}
                  inGracePeriod={this.state.inGracePeriod}
                  isPreExpired={this.state.isPreExpired}
                />
              )}
            {this.state.isMobile &&
              this.props.isVisible && (
                <div className="user-isloggedin">
                  <div className="user-controls">
                    <span className="user_name">
                      Hi,{' '}
                      <span>
                        {this.state.loggedIn ? this.state.firstName : 'User'}
                      </span>
                      {!this.state.isMobile && (
                        <i className="sprite_bg icon_down " />
                      )}
                    </span>
                  </div>
                </div>
              )}
            {!this.state.loggedIn &&
              this.state.isMobile &&
              this.props.isVisible && (
                <>
                  <span
                    className="redeembtn logout-window"
                    onClick={e => {
                      this.signInUser(e, false);
                      deleteSessionStorage('poll_widget_GA');
                      deleteSessionStorage('ga4EventTypeValue');
                    }}
                  >
                    LOGIN
                  </span>
                </>
              )}
            {!this.state.loggedIn &&
              !this.state.isMobile &&
              !this.props.isDefencePage && (
                <span className="logout-window">
                  {!this.props.isMobile &&
                    this.props.toipLayout && <div className="user-icon" />}
                  <span
                    className="login user-notloggedin"
                    onClick={e => {
                      if (
                        typeof window !== 'undefined' &&
                        typeof window.geoinfo.CountryCode === 'string' &&
                        window.geoinfo.CountryCode !== 'US'
                      ) {
                        window.dispatchEvent(
                          new Event('OneTapLogin.openOneTap'),
                        );
                      }
                      this.signInUser(e, false);
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: 'header',
                        category: `signin`,
                      });
                      deleteSessionStorage('poll_widget_GA');
                      deleteSessionStorage('ga4EventTypeValue');
                    }}
                  >
                    Sign In
                    {this.state.isPrimeUser ? <i /> : null}
                    {/* Sign In / Signup */}
                  </span>
                </span>
              )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
  openLogin: state.login.openLogin,
  userEmailid: state.login.userEmailid,
  isPrivateUser: state.gdpr.isPrivateUser,
  isPrime: state.isPrime,
  userPointsData: state.timesPoint ? state.timesPoint.userData : {},
  isAboundSignupChecked: !!state?.abound?.isAboundSignupChecked,
  allActivity: state.timespointmodal && state.timespointmodal.allActivity,
  isArticleshow: state?.isArticleshow,
  primeshow: state?.toiplusprimeshow,
  headerNudges: _get(state?.translationConfig?.nudges, 'header', null),
  isMobileState: _get(state, 'isMobile', false),
  userPrcData: state.login.userPrcData,
});

const mapDispatchToProps = dispatch => ({
  // setUserLoginStatus: params => {
  //   dispatch(userLoginStatus(params));
  // },
  loadAboundPoints: params => {
    dispatch(loadLoginAboundPoints(params));
  },
  storeUserData: params => {
    dispatch(userData(params));
  },
  toggleLoginBox: (isOpen, userEmailid = '') => {
    dispatch(toggleLoginBox(isOpen, userEmailid));
  },
  getUserPrcData: params => dispatch(getUserPrcData(params)),
});

Login.propTypes = {
  //setUserLoginStatus: PropTypes.func.isRequired,
  storeUserData: PropTypes.func.isRequired,
  isPrivateUser: PropTypes.bool,
  userPointsData: PropTypes.shape({}),
  //isPrime: PropTypes.bool,
  // isWap: PropTypes.bool,
  isVisible: PropTypes.bool,
  toggleLoginBox: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isMobileState: PropTypes.bool,
  userData: PropTypes.shape({
    prcValue: PropTypes.number,
    isLoggedIn: PropTypes.bool,
  }),
  focusNavigation: PropTypes.func,
  theme: PropTypes.string,
  query: PropTypes.shape({}),
  // fromEtimes: PropTypes.bool,
  // pageType: PropTypes.string,
  allActivity: PropTypes.arrayOf(PropTypes.shape({})),
  toipLayout: PropTypes.bool,
  skipReloadForPrimeLogin: PropTypes.bool,
};

Login.defaultProps = {
  isPrivateUser: true,
  userPointsData: {},
  allActivity: [],
  //isPrime: false,
  // isWap: false,
  isVisible: false,
  isMobile: false,
  isMobileState: false,
  userData: undefined,
  focusNavigation: undefined,
  theme: '',
  query: {},
  // fromEtimes: false,
  // pageType: '',
  toipLayout: false,
  skipReloadForPrimeLogin: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
